@if (user$ | async; as user) {
  <div class="breadcrumb-wrapper">
    <nav class="breadcrumb !m-0">
      <span class="material-symbols-rounded text-[#36442A]">groups</span>
      <div class="flex items-center gap-2">
        <a routerLink="/admin/users" class="breadcrumb-link">
          {{ "admin.userDetails.breadcrumb" | translate }}
        </a>
        <span class="text-[#8E96A3]">/</span>
        <span class="breadcrumb-current">
          {{ "admin.userDetails.breadcrumbCurrent" | translate }}
        </span>
      </div>
    </nav>

    <div class="relative w-52">
      <input
        (change)="onDateRangeChange($event)"
        [alwaysShowCalendars]="true"
        [autoApply]="true"
        [linkedCalendars]="true"
        [locale]="datepickerLocale"
        [showCancel]="false"
        [showClearButton]="true"
        [showDropdowns]="true"
        [opens]="'left'"
        [drops]="'down'"
        class="form-control cursor-pointer w-full border rounded text-sm"
        ngxDaterangepickerBootstrap
        [placeholder]="'admin.userDetails.filterByDate' | translate"
        readonly
        type="text"
      />
      <div
        class="absolute inset-y-0 right-2 flex items-center pointer-events-none"
      >
        <span class="material-symbols-rounded scale-75 text-[#6A7381]"
          >date_range</span
        >
      </div>
    </div>
  </div>

  <div class="user-details-container">
    <div class="user-header">
      <div class="user-info">
        <div class="user-info-top">
          <div class="flex flex-col gap-2">
            <p class="name">{{ user.name }}</p>
            <div class="user-meta">
              <p class="email">{{ user.email }}</p>
              <div class="flex gap-2">
                <p>{{ "admin.userDetails.profile" | translate }}:</p>
                <p class="profile">{{ user.profile }}</p>
              </div>
            </div>
          </div>
          <div class="user-status">
            <button
              (click)="openStatusModal()"
              class="py-2 px-12 border border-[#D0D6DF] rounded-md"
              [ngClass]="user.isActive ? 'text-[#F55241]' : 'text-[#28B04B]'"
            >
              {{
                user.isActive
                  ? ("admin.userDetails.disable" | translate)
                  : ("admin.userDetails.enable" | translate)
              }}
            </button>
          </div>
        </div>

        <div class="user-meta">
          @if (userStats$ | async; as userStats) {
            <div class="meta-item">
              <span
                class="material-symbols-rounded card-icon bg-green text-green"
              >
                task_alt
              </span>
              <div>
                <p class="value !m-0">{{ userStats.fileCount }}</p>
                <span class="label">{{
                  "admin.userDetails.totalConvertedFiles" | translate
                }}</span>
              </div>
            </div>
            <div class="meta-item">
              <img
                src="assets/images/Gerber1 1 1.svg"
                alt=""
                class="card-icon bg-blue"
              />
              <div>
                <p class="value !m-0">{{ userStats.gerberCount }}</p>
                <span class="label">{{ "file.type.gerber" | translate }}</span>
              </div>
            </div>
            <div class="meta-item">
              <img
                src="assets/images/lectra-icon 1.svg"
                alt=""
                class="card-icon bg-red"
              />
              <div>
                <p class="value !m-0">{{ userStats.lectraCount }}</p>
                <span class="label">{{ "file.type.lectra" | translate }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    @if (userStats$ | async; as userStats) {
      @if (chartData$ | async; as chartData) {
        <div class="charts-container">
          <app-chart-card
            class="w-[40%] h-full"
            [data]="[userStats.gerberCount, userStats.lectraCount]"
            [labels]="[
              'file.type.gerber' | translate,
              'file.type.lectra' | translate,
            ]"
            [title]="'admin.userDetails.chart.totalByType' | translate"
            [defaultType]="'donut'"
            [showTypeSwitcher]="true"
            [distributed]="true"
          />
          <app-chart-card
            class="w-[60%] h-full"
            [series]="chartData.series"
            [labels]="chartData.labels"
            [title]="'admin.userDetails.chart.byPeriod' | translate"
            [defaultType]="'bar'"
            [distributed]="false"
          />
        </div>
      }

      <div class="recent-activity">
        <p>{{ "admin.userDetails.recentActivity" | translate }}</p>
        <ul>
          @for (file of userStats.recentFiles; track $index) {
            <li [innerHTML]="getRecentEntryHtml(file)"></li>
          }
        </ul>
      </div>
    }
  </div>

  @if (showModal) {
    <app-user-status-modal
      [user]="user"
      (confirm)="confirmUpdateStatus()"
      (cancel)="closeStatusModal()"
    />
  }
}
